import React from "react";
import CardsPage from "components/common/cards/CardsPage";

const Cards: React.FC = () => <CardsPage />;

export default Cards;
